import zhCN from './zh-cn'
import enUS from './en-us'

export default {
  'zh-cn': zhCN,
  'en-us': enUS
} 